import { render, staticRenderFns } from "./eductionCount.vue?vue&type=template&id=0bb53498&scoped=true&"
import script from "./eductionCount.vue?vue&type=script&lang=js&"
export * from "./eductionCount.vue?vue&type=script&lang=js&"
import style0 from "./eductionCount.vue?vue&type=style&index=0&id=0bb53498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb53498",
  null
  
)

export default component.exports